var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1592 2.84079C11.3715 1.05307 8.473 1.05307 6.68528 2.84079L6.20472 3.32135C6.00945 3.51662 6.00945 3.8332 6.20471 4.02846C6.39998 4.22372 6.71656 4.22372 6.91182 4.02846L7.39239 3.54789C8.78958 2.1507 11.0549 2.1507 12.4521 3.54789C13.8493 4.94509 13.8493 7.21039 12.4521 8.60758L11.9715 9.08814C11.7762 9.28341 11.7762 9.59999 11.9715 9.79525C12.1668 9.99051 12.4834 9.99051 12.6786 9.79525L13.1592 9.31468C14.9469 7.52697 14.9469 4.62851 13.1592 2.84079Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02846 6.20471C4.22372 6.39998 4.22372 6.71656 4.02846 6.91182L3.54789 7.39239C2.1507 8.78958 2.1507 11.0549 3.54789 12.4521C4.94509 13.8493 7.21039 13.8493 8.60758 12.4521L9.08815 11.9715C9.28341 11.7762 9.59999 11.7762 9.79525 11.9715C9.99051 12.1668 9.99051 12.4834 9.79525 12.6786L9.31469 13.1592C7.52697 14.9469 4.62851 14.9469 2.84079 13.1592C1.05307 11.3715 1.05307 8.473 2.84079 6.68528L3.32135 6.20471C3.51662 6.00945 3.8332 6.00945 4.02846 6.20471Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79522 6.20471C9.99048 6.39998 9.99048 6.71656 9.79522 6.91182L6.91182 9.79522C6.71656 9.99048 6.39998 9.99048 6.20471 9.79522C6.00945 9.59995 6.00945 9.28337 6.20471 9.08811L9.08811 6.20471C9.28337 6.00945 9.59996 6.00945 9.79522 6.20471Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b77153c26a47a81d1369eb9e785a23e5.svg";
export { ForwardRef as ReactComponent };